import { orgName } from "./Constants";

export const strings = {
  contributor: "CONTRIBUTOR",
  sessionExpiredMsg: `Your ${orgName} session has expired. Login back to manage your account!`,
  sessionExpireMsg: `Your  ${orgName} session has expired. Please login back to manage your account.`,
  notEnoughLicense: "Not enough license, Please select new application.",
  sessionExpiringSoon: "Session Expiring Soon",
  sessionExpired: "Session Expired",
  sessionWillExpire: "For the safety of your privacy, your session will expire in",
  someThingWentWrong: "Something went wrong!!",
  fileUploading: "File Upload in Progress",
  fileUploadingMessage: "Please wait while your files are being uploaded...",
  fileUploadedMessage: "Documents have been uploaded successfully",
  sessionSignOut: "Signout",
  sessionSignIn: "Stay Signed In",
  sessionExpire: "Your session is about to expire!",
  sessionInactive: "You have been inactive for a while. for the safety of your privacy, your session will expire in ",
  clmExplain: "This is a system used to manage content",
  firstStep:
    "As a new user, your journey begins with requesting access. Click the “Start” button below to select your division.",
  requestPara:
    "After selecting your division, proceed by choosing the modules relevant to your role. Once done, await approval from the admin team.",
  sessionMinutes: "Minutes.",
  underReview:
    "Your request for module access is presently under review. Our administrative team is diligently evaluating your access request, and we appreciate your patience throughout this process. Thank you for your understanding, and we will notify you promptly once your access is granted.",
  noData: "No data",
  lhdn: "The LHDN stamping process takes place after the vendors have signed the contract document. The user gathers details of the LHDN Stampers to upload the LHDN stamped document back into the CLM through DocuSign. The LHDN Stamper receives the specific document in DocuSign, prints it, obtains the stamp from the LHDN Portal, and uploads it back to DocuSign.",
  adminInfo:
    "On Removing Admin role by default this user will be assigned to LOA Creator Role since a user cannot be present without having any roles assigned to them.",
  commercialInfo:
    "On Removing Admin role by default this user will be assigned to CMU Creator Role since a user cannot be present without having any roles assigned to them.",
  legalInfo:
    "On Removing Admin role by default this user will be assigned to Legal User Role since a user cannot be present without having any roles assigned to them.",
  ok: "Okay",
  na: "N/A",
  note: "Note!",
  note1: "By changing the current preferred currency, it may reflects to all users.",
  note2: "If you change currency it will take around ",
  noteTime: "30 minutes ",
  note3: "to reflect.",
};
